import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const OptionsIcon = ({
  color = RoutalPalette.grey1,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 17.75 17.39" style={{ width: `16px`, height: `16px`, color, ...props.style }}>
      <g>
        <path d="M7.33,14.26H1.38c-.11,0-.2-.09-.2-.21V1.36c0-.11.09-.2.2-.2h13.01c.11,0,.2.09.2.2v5.92l1,.27V1.36c0-.66-.54-1.2-1.2-1.2H1.38C.72.16.18.7.18,1.36v12.69c0,.66.54,1.21,1.2,1.21h6.18l-.23-1Z" />
        <path d="M9.98,17.23s-.08,0-.11,0c-.44-.05-.79-.35-.9-.77l-2.39-8.94c-.1-.37,0-.75.27-1.01.27-.27.64-.37,1.01-.27l8.94,2.39c.42.11.73.47.77.9s-.18.85-.57,1.04l-4.01,2.05-2.07,4.04c-.18.36-.54.57-.93.57ZM7.54,7.26l2.39,8.94,2.14-4c.1-.2.26-.36.46-.46l4.02-2.05-8.95-2.49-.06.06h0Z" />
      </g>
    </SvgIcon>
  );
};
